import queryString from "query-string";
import { format } from "date-fns";
import { sidebarFiltersTags } from "./local-storage/sidebar-options";
import {
    createSelectedPeriodState,
    defaultPeriodsGeneralStatus,
} from "./fns/generate-period-state";

/**
 * 
 * @param {Object} search - Parámetros de búsqueda de la URL
 * @description Genera filtros por defecto basados en los parámetros de consulta de la URL.
 * Extrae etiquetas, periodo, fechas de inicio y fin, y el tipo de filtro.
 * Crea un estado de periodo seleccionado y un objeto activo con el periodo actual.
 * Si el periodo es personalizado, formatea las fechas de inicio y fin.
 * Retorna un objeto con el estado del periodo seleccionado, el objeto activo, el tipo de filtro y las etiquetas. 
 * @returns {Object} Objeto con los filtros por defecto generados a partir de los parámetros de consulta.
 * @property {Object} selectedPeriodState - Estado del periodo seleccionado.
 * @property {Object} active - Objeto activo con el periodo actual.
 * @property {string} filterType - Tipo de filtro seleccionado.
 * @property {Array} etiquetas - Lista de etiquetas extraídas de los parámetros de consulta.
 * @author David Maldonado
 * @version 1.0.0
 */
export function generateDefaultFilters(search) {
    const parsed = queryString.parse(search);
    const etiquetas =
        parsed?.etiquetas && parsed?.etiquetas !== ""
            ? parsed?.etiquetas.split("T").map((e) => Number(e)) ?? []
            : [];
    const PERIODOS = [
        "hora",
        "3hora",
        "6hora",
        "12hora",
        "dia",
        "2dia",
        "semana",
        "2semana",
        "mes",
        "c",
    ];
    const periodo =
        parsed?.periodo &&
        parsed?.periodo !== "" &&
        parsed?.periodo !== "0" &&
        PERIODOS.includes(parsed?.periodo)
            ? parsed?.periodo
            : "dia";

    const startDate = new Date(`${parsed.startDate} 00:00`);
    const endDate = new Date(`${parsed.endDate} 23:59`);

    const selectedPeriodState = createSelectedPeriodState(
        periodo || "dia",
        0,
        periodo === "c"
            ? {
                  startDate,
                  endDate,
              }
            : null
    );

    let active = defaultPeriodsGeneralStatus.filter(
        (item) => item.period === periodo ?? "dia"
    )[0];
    if (periodo === "c") {
        const text = `Custom: ${format(startDate, "dd/MM/yyyy")} - ${format(
            endDate,
            "dd/MM/yyyy"
        )}`;

        active = {
            value: "custom",
            statePeriod: {
                startDate,
                endDate,
                key: "selection",
            },
            text,
            period: "c",
        };
    }

    const filterTypeFromStorage = sidebarFiltersTags.getFilterType();
    const filterType = parsed?.filterType ?? filterTypeFromStorage;

    return { selectedPeriodState, active, filterType, etiquetas };
}
